// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9uyo8","name":"Header_name__yreoP","birthday":"Header_birthday__n4xn5","skeleton":"Header_skeleton__23QHf"};